<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Pedido"
                        @click="add()">
                <AppIcon name="add" label="Agregar Pedido" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Nº Pedido</label>
              <b-form-input type="number" size="sm" placeholder="Buscar por Nº" v-model="filters.number" v-on:keyup.enter.native="filterOrders()"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 340px;">
              <label class="filter-label">Clientes</label>
              <v-select :options="arr.filters.customers" v-model="filters.customers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.filters.status" v-model="filters.status" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Punto de Venta</label>
              <v-select :options="arr.filters.points_sales" v-model="filters.points_sales" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="moduleSellersActive">
              <label class="filter-label">Vendedores</label>
              <v-select :options="arr.filters.sellers" v-model="filters.sellers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="parameters.remitFromOrder">
              <label class="filter-label">Remitido</label>
              <v-select :options="arr.filters.remitted" v-model="filters.remitted" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="parameters.haveReason">
              <label class="filter-label">Motivos</label>
              <v-select :options="arr.filters.reasons" v-model="filters.reason" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="moduleSalesActive">
              <label class="filter-label">Facturación</label>
              <v-select :options="arr.filters.invoiced" v-model="filters.invoiced" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterOrders()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card no-body>
            <b-tabs pills card :vertical="!isMobileViewport" class="crud-orders-view-tabs">
              <b-tab @click="metricsActive = false">
                <template #title>
                  <AppIcon name="cart" label="Pedidos" font-scale="1.5" />
                </template>
                <b-card-text>
                  <b-card>
                    <b-row>
                      <b-col sm="12">
                        <b-form-checkbox v-model="filters.show_total_iva"
                                          switch
                                          size="sm"
                                          class="pull-left mb-2"
                                          @input="filterOrders()">
                          Mostrar totales con IVA incluido
                        </b-form-checkbox>
                      </b-col>
                    </b-row>

                    <b-tabs justified active-nav-item-class="font-weight-bold text-uppercase text-dark" id="tab-orders">
                      <b-tab title="Mayorista" v-if="showView.wholesaler" @click="selectRenderView('wholesaler')">

                        <b-table class="app-table"
                                ref="table"
                                responsive
                                :stacked="isMobileViewport ? 'md' : false"
                                sticky-header="60vh"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="table.items"
                                :fields="table.fields"
                                :current-page="table.currentPage"
                                :per-page="table.perPage"
                                @row-clicked="onRowClicked"
                                :tbody-tr-class="rowClass"
                                :busy="table.isBusy"
                                v-if="table.items.length || table.isBusy">

                            <template v-slot:table-colgroup="scope">
                              <col
                                v-for="field in scope.fields"
                                :key="field.key"
                                :style="{ width: field.width }"
                              >
                            </template>

                            <template v-slot:table-busy>
                              <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                              </div>
                            </template>

                            <template v-slot:cell(business)="data">
                              <div v-if="data.item.points_sales && data.item.points_sales.business">
                                {{data.item.points_sales.business.reference}}
                              </div>
                            </template>

                            <template v-slot:cell(id)="data">
                              <div title="Numeración del sistema" class="text-nowrap" v-if="data.item.points_sales">
                                PEDIDO {{data.item.points_sales.point_sale.toString().padStart(4,'0') + '-' + data.item.id.toString().padStart(8,'0')}}
                              </div>
                              <div v-if="data.item.nro_order_internal"
                                  title="Numeración de un sistema externo"
                                  class="crud-orders-nro-internal">
                                <AppIcon name="link-45deg" />
                                <b>{{data.item.nro_order_internal}}</b>
                              </div>
                            </template>

                            <template v-slot:cell(date)="data">
                              {{moment(data.item.date).format('DD/MM/YYYY')}}
                              <div style="font-size:0.7rem;color:rgb(46 46 46);">{{moment(data.item.created_at).format('HH:mm')}}</div>
                            </template>

                            <template v-slot:cell(sellers_id)="data">
                              <span v-if="data.item.sellers_id" v-b-tooltip.hover :title="'VENDEDOR: ' + data.item.seller.staff.name">
                                <b-avatar :src="data.item.seller.staff.image"
                                          v-if="data.item.seller.staff.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.seller.staff.name).text"
                                          :style="avatarFromName(data.item.seller.staff.name).style">
                                </b-avatar>
                                <span v-if="isMobileViewport" class="ml-2">{{data.item.seller.staff.name}}</span>
                              </span>
                            </template>

                            <template v-slot:cell(staff_id)="data">
                              <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name">
                                <b-avatar :src="data.item.staff.image"
                                          v-if="data.item.staff.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.staff.name).text"
                                          :style="avatarFromName(data.item.staff.name).style">
                                </b-avatar>
                                <span v-if="isMobileViewport" class="ml-2">{{data.item.staff.name}}</span>
                              </span>
                            </template>

                            <template v-slot:cell(customers_id)="data">
                              <div v-if="data.item.customer">
                                <b-avatar :src="data.item.customer.image"
                                          v-if="data.item.customer.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.customer.name).text"
                                          :style="avatarFromName(data.item.customer.name).style">
                                </b-avatar>
                                &nbsp;<b>{{data.item.customer.name}}</b>

                                <span v-if="data.item.customer.bcra_status">
                                  <span v-if="data.item.customer.bcra_status.situacion > situationCreditMax">
                                    &nbsp;
                                    <b-badge variant="danger" :id="'popover-situation-' + data.item.id">
                                      Sit {{data.item.customer.bcra_status.situacion}}
                                    </b-badge>
                                    <b-popover :target="'popover-situation-' + data.item.id" variant="danger" triggers="hover">
                                      <template #title>Riesgo Creditício</template>
                                      <div v-html="situationCreditMessage(data.item)"></div>
                                    </b-popover>
                                  </span>
                                </span>

                                <AppIcon name="circle-fill" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                              </div>
                              <div v-if="hasConsumerData(data.item)" class="crud-orders-consumer-extra">
                                <span :id="'popover-consumer-wholesaler-' + data.item.id"
                                      class="crud-orders-consumer-trigger">
                                  <AppIcon name="person-badge" />
                                  <span>{{ getConsumerTriggerLabel(data.item) }}</span>
                                </span>
                                <b-popover :target="'popover-consumer-wholesaler-' + data.item.id"
                                          triggers="hover"
                                          placement="right">
                                  <template #title>Consumidor Final</template>
                                  <div class="crud-orders-consumer-popover">
                                    <div v-for="itemConsumer in getConsumerDetailRows(data.item)" :key="'wholesaler-consumer-' + data.item.id + '-' + itemConsumer.key" class="crud-orders-consumer-popover-row">
                                      <span class="crud-orders-consumer-popover-label">{{ itemConsumer.label }}:</span>
                                      <span class="crud-orders-consumer-popover-value">{{ itemConsumer.value }}</span>
                                    </div>
                                  </div>
                                </b-popover>
                              </div>
                            </template>

                            <template v-slot:cell(total)="data">
                              <div v-if="data.item.status!='in_process'">
                                <div v-if="data.item.paid" class="order-total-table-paid">
                                  <span v-if="filters.show_total_iva">
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.totalIva)}}
                                  </span>
                                  <span v-else>
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.total)}}
                                  </span>
                                </div>
                                <div v-else class="order-total-table-nopaid">
                                  <span v-if="filters.show_total_iva">
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.totalIva)}}
                                  </span>
                                  <span v-else>
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.total)}}
                                  </span>
                                </div>
                              </div>
                            </template>

                            <template v-slot:cell(status)="data">
                              <div v-html="getStatusName(data.item)"></div>
                            </template>

                            <template v-slot:cell(reason)="data">
                              <div v-if="data.item.reason">
                                <span v-if="data.item.reason.reference">
                                  {{data.item.reason.reference}}
                                </span>
                                <span v-else>
                                  {{data.item.reason.name}}
                                </span>
                              </div>
                            </template>

                            <template v-slot:cell(status_system_manufacture)="data">
                              <span v-if="data.item.status_system_manufacture">
                                <span v-if="JSON.parse(data.item.status_system_manufacture).status == 'error'" v-b-tooltip.hover :title="JSON.parse(data.item.status_system_manufacture).message">
                                  <AppIcon name="exclamation-triangle" class="text-danger" />
                                </span>
                              </span>
                            </template>

                            <template v-slot:cell(observations)="data">
                              <div v-if="data.item.observation">
                                <span v-if="isMobileViewport">{{data.item.observation}}</span>
                                <span v-else v-b-tooltip.hover :title="data.item.observation"><AppIcon name="chat-square-text" /></span>
                              </div>
                              <div v-if="data.item.observations_external">
                                <span v-if="isMobileViewport" v-html="data.item.observations_external" class="text-info"></span>
                                <span v-else :id="'popover-observations-external-' + data.index" class="text-info"><AppIcon name="chat-square-text" /></span>
                              </div>
                              <b-popover :target="'popover-observations-external-' + data.index"
                                        variant="danger"
                                        triggers="hover"
                                        v-if="data.item.observations_external && !isMobileViewport">
                                <template #title>Notas</template>
                                <div v-html="data.item.observations_external"></div>
                              </b-popover>
                            </template>

                            <template v-slot:cell(paid_info)="data">
                              <div v-if="data.item.paid_info" v-b-tooltip.hover :title="data.item.paid_info">
                                <AppIcon name="money" />
                              </div>
                            </template>

                            <template v-slot:cell(delivery_code_tracking)="data">
                              <div v-if="data.item.delivery_code_tracking" v-b-tooltip.hover :title="data.item.delivery_code_tracking">
                                <AppIcon name="truck" />
                              </div>
                            </template>

                            <template v-slot:cell(invoice)="data">
                              <div v-if="data.item.sale_id" v-b-tooltip.hover :title="getInvoiceTitle(data.item)">
                                <AppIcon name="receipt_long" />
                              </div>
                            </template>

                            <template v-slot:cell(f_action)="data">
                              <b-dropdown right
                                          no-caret
                                          size="sm"
                                          variant="link"
                                          boundary="window"
                                          :toggle-class="isMobileViewport ? 'app-table-action-toggle-mobile' : 'app-table-action-toggle'"
                                          class="app-table-action-dropdown">
                                <template #button-content>
                                  <AppIcon name="more_vert" label="Acciones" />
                                  <span v-if="isMobileViewport" class="ml-1">Opciones</span>
                                </template>

                                <b-dropdown-item @click="sendPrinterOrder(data.item)" v-if="data.item.status!='in_process'">
                                  <AppIcon name="print" /> Imprimir
                                </b-dropdown-item>
                                <b-dropdown-item @click="sendEmailOrder(data.item)" v-if="data.item.status!='in_process'">
                                  <AppIcon name="mail" /> Reenviar Email
                                </b-dropdown-item>

                                <b-dropdown-header v-if="showGenerateRemits(data.item) || showGenerateInvoice(data.item)">
                                  ERP
                                </b-dropdown-header>
                                <b-dropdown-item @click="generateRemits(data.item)" v-if="showGenerateRemits(data.item)">
                                  <AppIcon name="reports" /> Remitar
                                </b-dropdown-item>
                                <b-dropdown-item @click="generateInvoice(data.item)" v-if="showGenerateInvoice(data.item)">
                                  <AppIcon name="receipt_long" /> Facturar
                                </b-dropdown-item>

                                <b-dropdown-header v-if="showNextStatus(data.item) || showPreviousStatus(data.item) || showCancelStatus(data.item) || showRestoreStatus(data.item)">
                                  Estados
                                </b-dropdown-header>
                                <b-dropdown-item @click="nextStatus(data.item)" v-if="showNextStatus(data.item)">
                                  <AppIcon name="chevron-right" /> Próximo Estado
                                </b-dropdown-item>
                                <b-dropdown-item @click="previousStatus(data.item)" v-if="showPreviousStatus(data.item)">
                                  <AppIcon name="chevron-left" /> Estado Anterior
                                </b-dropdown-item>

                                <b-dropdown-item @click="cancelStatus(data.item)" v-if="showCancelStatus(data.item)">
                                  <AppIcon name="x-circle" /> Cancelar Pedido
                                </b-dropdown-item>
                                <b-dropdown-item @click="closedStatus(data.item)" v-if="showRestoreStatus(data.item)">
                                  <AppIcon name="refresh" /> Reestablecer Pedido
                                </b-dropdown-item>

                                <b-dropdown-header v-if="parameters.haveNroInteral && data.item.status!='in_process'">
                                  Asociación
                                </b-dropdown-header>
                                <b-dropdown-item @click="openNroOrderInternal(data.item)" v-if="parameters.haveNroInteral && data.item.status!='in_process'">
                                  <AppIcon name="link-45deg" /> Agregar Nro Interno
                                </b-dropdown-item>

                                <b-dropdown-header>Acciones</b-dropdown-header>
                                <b-dropdown-item @click="edit(data.item)" v-if="data.item.status=='closed'">
                                  <AppIcon name="edit" class="text-primary" /> Editar
                                </b-dropdown-item>
                                <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteOrders">
                                  <AppIcon name="delete" class="text-danger" /> Eliminar
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                        </b-table>
                        <EmptyState v-else icon="cart" title="No se encontraron pedidos" description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá un pedido nuevo con el botón Agregar." />

                        <div class="app-table-footer">
                          <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                          <export-excel
                              class="list-view-link"
                              :data="arr.export"
                              worksheet="Listado de Pedidos"
                              name="list-orders.xls">
                              <AppIcon name="download" class="mr-1" /> Exportar
                          </export-excel>
                        </div>

                      </b-tab>
                      <b-tab title="Minorista" v-if="showView.retailer" @click="selectRenderView('retailer')">

                        <b-table class="app-table"
                                ref="table"
                                responsive
                                :stacked="isMobileViewport ? 'md' : false"
                                sticky-header="60vh"
                                :hover="true"
                                :small="true"
                                :fixed="true"
                                :items="table.items"
                                :fields="table.fields"
                                :current-page="table.currentPage"
                                :per-page="table.perPage"
                                @row-clicked="onRowClicked"
                                :tbody-tr-class="rowClass"
                                :busy="table.isBusy"
                                v-if="table.items.length || table.isBusy">

                            <template v-slot:table-colgroup="scope">
                              <col
                                v-for="field in scope.fields"
                                :key="field.key"
                                :style="{ width: field.width }"
                              >
                            </template>

                            <template v-slot:table-busy>
                              <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Cargando...</strong>
                              </div>
                            </template>

                            <template v-slot:cell(business)="data">
                              <div v-if="data.item.points_sales && data.item.points_sales.business">
                                {{data.item.points_sales.business.reference}}
                              </div>
                            </template>

                            <template v-slot:cell(id)="data">
                              <div title="Numeración del sistema" class="text-nowrap" v-if="data.item.points_sales">
                                PEDIDO {{data.item.points_sales.point_sale.toString().padStart(4,'0') + '-' + data.item.id.toString().padStart(8,'0')}}
                              </div>
                              <div v-if="data.item.nro_order_internal"
                                  title="Numeración de un sistema externo"
                                  class="crud-orders-nro-internal">
                                <AppIcon name="link-45deg" />
                                <b>{{data.item.nro_order_internal}}</b>
                              </div>
                            </template>

                            <template v-slot:cell(date)="data">
                              {{moment(data.item.date).format('DD/MM/YYYY')}}
                            </template>

                            <template v-slot:cell(sellers_id)="data">
                              <span v-if="data.item.sellers_id" v-b-tooltip.hover :title="'VENDEDOR: ' + data.item.seller.staff.name">
                                <b-avatar :src="data.item.seller.staff.image"
                                          v-if="data.item.seller.staff.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.seller.staff.name).text"
                                          :style="avatarFromName(data.item.seller.staff.name).style">
                                </b-avatar>
                                <span v-if="isMobileViewport" class="ml-2">{{data.item.seller.staff.name}}</span>
                              </span>
                            </template>

                            <template v-slot:cell(staff_id)="data">
                              <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name">
                                <b-avatar :src="data.item.staff.image"
                                          v-if="data.item.staff.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.staff.name).text"
                                          :style="avatarFromName(data.item.staff.name).style">
                                </b-avatar>
                                <span v-if="isMobileViewport" class="ml-2">{{data.item.staff.name}}</span>
                              </span>
                            </template>

                            <template v-slot:cell(customers_id)="data">
                              <div v-if="data.item.customer">
                                <b-avatar :src="data.item.customer.image"
                                          v-if="data.item.customer.image">
                                </b-avatar>
                                <b-avatar v-else
                                          :text="avatarFromName(data.item.customer.name).text"
                                          :style="avatarFromName(data.item.customer.name).style">
                                </b-avatar>
                                &nbsp;<b>{{data.item.customer.name}}</b>

                                <span v-if="data.item.customer.bcra_status">
                                  <span v-if="data.item.customer.bcra_status.situacion > situationCreditMax">
                                    &nbsp;
                                    <b-badge variant="danger" :id="'popover-situation-' + data.item.id">
                                      Sit {{data.item.customer.bcra_status.situacion}}
                                    </b-badge>
                                    <b-popover :target="'popover-situation-' + data.item.id" variant="danger" triggers="hover">
                                      <template #title>Riesgo Creditício</template>
                                      <div v-html="situationCreditMessage(data.item)"></div>
                                    </b-popover>
                                  </span>
                                </span>

                                <AppIcon name="circle-fill" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                              </div>
                              <div v-if="hasConsumerData(data.item)" class="crud-orders-consumer-extra">
                                <span :id="'popover-consumer-retailer-' + data.item.id"
                                      class="crud-orders-consumer-trigger">
                                  <AppIcon name="person-badge" />
                                  <span>{{ getConsumerTriggerLabel(data.item) }}</span>
                                </span>
                                <b-popover :target="'popover-consumer-retailer-' + data.item.id"
                                          triggers="hover"
                                          placement="right">
                                  <template #title>Consumidor Final</template>
                                  <div class="crud-orders-consumer-popover">
                                    <div v-for="itemConsumer in getConsumerDetailRows(data.item)" :key="'retailer-consumer-' + data.item.id + '-' + itemConsumer.key" class="crud-orders-consumer-popover-row">
                                      <span class="crud-orders-consumer-popover-label">{{ itemConsumer.label }}:</span>
                                      <span class="crud-orders-consumer-popover-value">{{ itemConsumer.value }}</span>
                                    </div>
                                  </div>
                                </b-popover>
                              </div>
                            </template>

                            <template v-slot:cell(total)="data">
                              <div v-if="data.item.status!='in_process'">
                                <div v-if="data.item.paid" class="order-total-table-paid">
                                  <span v-if="filters.show_total_iva">
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.totalIva)}}
                                  </span>
                                  <span v-else>
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.total)}}
                                  </span>
                                </div>
                                <div v-else class="order-total-table-nopaid">
                                  <span v-if="filters.show_total_iva">
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.totalIva)}}
                                  </span>
                                  <span v-else>
                                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:data.item.origin_currency_code}).format(data.item.total)}}
                                  </span>
                                </div>
                              </div>
                            </template>

                            <template v-slot:cell(status)="data">
                              <div v-html="getStatusName(data.item)"></div>
                            </template>

                            <template v-slot:cell(reason)="data">
                              <div v-if="data.item.reason">{{data.item.reason.name}}</div>
                            </template>

                            <template v-slot:cell(status_system_manufacture)="data">
                              <span v-if="data.item.status_system_manufacture">
                                <span v-if="JSON.parse(data.item.status_system_manufacture).status == 'error'" v-b-tooltip.hover :title="JSON.parse(data.item.status_system_manufacture).message">
                                  <AppIcon name="exclamation-triangle" class="text-danger" />
                                </span>
                              </span>
                            </template>

                            <template v-slot:cell(observations)="data">
                              <div v-if="data.item.observation">
                                <span v-if="isMobileViewport">{{data.item.observation}}</span>
                                <span v-else v-b-tooltip.hover :title="data.item.observation"><AppIcon name="chat-square-text" /></span>
                              </div>
                              <div v-if="data.item.observations_external">
                                <span v-if="isMobileViewport" v-html="data.item.observations_external" class="text-info"></span>
                                <span v-else :id="'popover-observations-external-' + data.index" class="text-info"><AppIcon name="chat-square-text" /></span>
                              </div>
                              <b-popover :target="'popover-observations-external-' + data.index"
                                        variant="danger"
                                        triggers="hover"
                                        v-if="data.item.observations_external && !isMobileViewport">
                                <template #title>Notas</template>
                                <div v-html="data.item.observations_external"></div>
                              </b-popover>
                            </template>

                            <template v-slot:cell(paid_info)="data">
                              <div v-if="data.item.paid" v-b-tooltip.hover :title="data.item.paid_info">
                                <AppIcon name="money" />
                              </div>
                            </template>

                            <template v-slot:cell(delivery_code_tracking)="data">
                              <div v-if="data.item.delivery_code_tracking" v-b-tooltip.hover :title="data.item.delivery_code_tracking">
                                <AppIcon name="truck" />
                              </div>
                            </template>

                            <template v-slot:cell(invoice)="data">
                              <div v-if="data.item.sale_id" v-b-tooltip.hover :title="getInvoiceTitle(data.item)">
                                <AppIcon name="receipt_long" />
                              </div>
                            </template>

                            <template v-slot:cell(f_action)="data">
                              <b-dropdown right
                                          no-caret
                                          size="sm"
                                          variant="link"
                                          boundary="window"
                                          :toggle-class="isMobileViewport ? 'app-table-action-toggle-mobile' : 'app-table-action-toggle'"
                                          class="app-table-action-dropdown">
                                <template #button-content>
                                  <AppIcon name="more_vert" label="Acciones" />
                                  <span v-if="isMobileViewport" class="ml-1">Opciones</span>
                                </template>

                                <b-dropdown-item @click="sendPrinterOrder(data.item)" v-if="data.item.status!='in_process'">
                                  <AppIcon name="print" /> Imprimir
                                </b-dropdown-item>
                                <b-dropdown-item @click="sendEmailOrder(data.item)" v-if="data.item.status!='in_process'">
                                  <AppIcon name="mail" /> Reenviar Email
                                </b-dropdown-item>

                                <b-dropdown-header v-if="showGenerateRemits(data.item) || showGenerateInvoice(data.item)">
                                  ERP
                                </b-dropdown-header>
                                <b-dropdown-item @click="generateRemits(data.item)" v-if="showGenerateRemits(data.item)">
                                  <AppIcon name="reports" /> Remitar
                                </b-dropdown-item>
                                <b-dropdown-item @click="generateInvoice(data.item)" v-if="showGenerateInvoice(data.item)">
                                  <AppIcon name="receipt_long" /> Facturar
                                </b-dropdown-item>

                                <b-dropdown-header v-if="showNextStatus(data.item) || showPreviousStatus(data.item) || showCancelStatus(data.item) || showRestoreStatus(data.item)">
                                  Estados
                                </b-dropdown-header>
                                <b-dropdown-item @click="nextStatus(data.item)" v-if="showNextStatus(data.item)">
                                  <AppIcon name="chevron-right" /> Próximo Estado
                                </b-dropdown-item>
                                <b-dropdown-item @click="previousStatus(data.item)" v-if="showPreviousStatus(data.item)">
                                  <AppIcon name="chevron-left" /> Estado Anterior
                                </b-dropdown-item>

                                <b-dropdown-item @click="cancelStatus(data.item)" v-if="showCancelStatus(data.item)">
                                  <AppIcon name="x-circle" /> Cancelar Pedido
                                </b-dropdown-item>
                                <b-dropdown-item @click="closedStatus(data.item)" v-if="showRestoreStatus(data.item)">
                                  <AppIcon name="refresh" /> Reestablecer Pedido
                                </b-dropdown-item>

                                <b-dropdown-header v-if="showPaid(data.item) || showCancelPaid(data.item)">
                                  Pagos
                                </b-dropdown-header>
                                <b-dropdown-item @click="getLinkPay(data.item)" v-if="showPaid(data.item)">
                                  <AppIcon name="link-45deg" /> Obtener Link
                                </b-dropdown-item>
                                <b-dropdown-item @click="changePaid(data.item)" v-if="showPaid(data.item)">
                                  <AppIcon name="money" /> Forzar pagado
                                </b-dropdown-item>
                                <b-dropdown-item @click="changePaid(data.item)" v-if="showCancelPaid(data.item)">
                                  <AppIcon name="x-circle" /> Cancelar pago
                                </b-dropdown-item>

                                <b-dropdown-header v-if="parameters.haveNroInteral && data.item.status!='in_process'">
                                  Asociación
                                </b-dropdown-header>
                                <b-dropdown-item @click="openNroOrderInternal(data.item)" v-if="parameters.haveNroInteral && data.item.status!='in_process'">
                                  <AppIcon name="link-45deg" /> Agregar Nro Interno
                                </b-dropdown-item>

                                <b-dropdown-header>Acciones</b-dropdown-header>
                                <b-dropdown-item @click="edit(data.item)" v-if="data.item.status=='closed'">
                                  <AppIcon name="edit" class="text-primary" /> Editar
                                </b-dropdown-item>
                                <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteOrders">
                                  <AppIcon name="delete" class="text-danger" /> Eliminar
                                </b-dropdown-item>
                              </b-dropdown>
                            </template>
                        </b-table>
                        <EmptyState v-else icon="cart" title="No se encontraron pedidos" description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá un pedido nuevo con el botón Agregar." />

                        <div class="app-table-footer">
                          <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                          <export-excel
                              class="list-view-link"
                              :data="arr.export"
                              worksheet="Listado de Pedidos"
                              name="list-orders.xls">
                              <AppIcon name="download" class="mr-1" /> Exportar
                          </export-excel>
                        </div>

                      </b-tab>
                    </b-tabs>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab @click="metricsActive = true; filterOrdersMetrics()">
                <template #title>
                  <AppIcon name="graph-up" label="Métricas" font-scale="1.5" />
                </template>
                <b-card-text>
                  <Metrics types="orders" :filters="filters" :key="itemFilterForceUpdate" v-if="itemFilterForceUpdate>0" @refresh="filterOrdersMetrics" />
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle del pedido seleccionado -->
      <b-sidebar
          id="sidebar-order-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Pedido"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.points_sales">
                PEDIDO {{itemSelected.points_sales.point_sale.toString().padStart(4,'0') + '-' + itemSelected.id.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{itemSelected.customer.name}}</div>
              <div class="list-view-drawer__meta" v-if="itemSelected.date">
                {{moment(itemSelected.date).format('DD/MM/YYYY')}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevOrder"
                        v-b-tooltip.hover
                        title="Pedido anterior"
                        @click="goPrevOrder()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextOrder"
                        v-b-tooltip.hover
                        title="Pedido siguiente"
                        @click="goNextOrder()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat" v-if="itemSelected.status!='in_process'">
              <span class="list-view-drawer__stat-label">Total</span>
              <span class="list-view-drawer__stat-value" :class="itemSelected.paid ? 'order-total-table-paid' : 'order-total-table-nopaid'">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(filters.show_total_iva ? itemSelected.totalIva : itemSelected.total)}}
              </span>
            </div>
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Estado</span>
              <span class="list-view-drawer__stat-value" v-html="getStatusName(itemSelected)"></span>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="list-ul" /> Detalle
            </div>

            <b-table  class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(quantity)="row">
                {{row.item.quantity}}
                <span v-if="row.item.unit_measurement">{{row.item.unit_measurement.reference}}</span>
              </template>

              <template v-slot:cell(product)="row">
                <div class="text-truncate" v-b-tooltip.hover :title="getProductName(row.item).replace(/<[^>]*>/g, '')" v-html="getProductName(row.item)"></div>
              </template>

            </b-table>
            <EmptyState v-else icon="list-ul" title="Sin items cargados" />
          </div>

          <b-button v-if="tableSub.items.length"
                    block
                    size="sm"
                    variant="outline-secondary"
                    class="text-left"
                    @click="openDetail()">
            <AppIcon name="visibility" class="mr-1" /> Ver detalle completo
          </b-button>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="sendPrinterOrder(itemSelected)" v-if="itemSelected.status!='in_process'">
              <AppIcon name="print" class="mr-1" /> Imprimir
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="sendEmailOrder(itemSelected)" v-if="itemSelected.status!='in_process'">
              <AppIcon name="mail" class="mr-1" /> Reenviar Email
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showGenerateRemits(itemSelected)" @click="generateRemits(itemSelected)">
              <AppIcon name="reports" class="mr-1" /> Remitar
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showGenerateInvoice(itemSelected)" @click="generateInvoice(itemSelected)">
              <AppIcon name="receipt_long" class="mr-1" /> Facturar
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showNextStatus(itemSelected)" @click="nextStatus(itemSelected)">
              <AppIcon name="chevron-right" class="mr-1" /> Próximo Estado
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showPreviousStatus(itemSelected)" @click="previousStatus(itemSelected)">
              <AppIcon name="chevron-left" class="mr-1" /> Estado Anterior
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showCancelStatus(itemSelected)" @click="cancelStatus(itemSelected)">
              <AppIcon name="x-circle" class="mr-1" /> Cancelar Pedido
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showRestoreStatus(itemSelected)" @click="closedStatus(itemSelected)">
              <AppIcon name="refresh" class="mr-1" /> Reestablecer Pedido
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.is_retail && showPaid(itemSelected)" @click="getLinkPay(itemSelected)">
              <AppIcon name="link-45deg" class="mr-1" /> Obtener Link de Pago
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.is_retail && showPaid(itemSelected)" @click="changePaid(itemSelected)">
              <AppIcon name="money" class="mr-1" /> Forzar pagado
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.is_retail && showCancelPaid(itemSelected)" @click="changePaid(itemSelected)">
              <AppIcon name="x-circle" class="mr-1" /> Cancelar pago
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="parameters.haveNroInteral && itemSelected.status!='in_process'" @click="openNroOrderInternal(itemSelected)">
              <AppIcon name="link-45deg" class="mr-1" /> Nro Interno
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="itemSelected.status=='closed'" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && access.elements.deleteOrders">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate && !metricsActive">
                <b-pagination class="mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterOrders()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <div id="link_container"></div>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id"
              :reference="crud.print.reference"
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              dialog-class="orders-form-modal-dialog"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-orders-wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="orderValidDetailGeneral">
            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="customers"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :disabled="crud.form.id>0"/>
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="erpPointsSales"
                            auto-select-single
                            display="full_identification"
                            @select-object="loadPointsSales($event)"
                            :valueID="crud.form.erp_points_sales_id"
                            :key="crud.form.erp_points_sales_id"
                            :showAllRegister="true"
                            :where="conditionPointsSalesActive" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsPayment"
                            auto-select-single
                            @select-object="loadMethodsPayment($event)"
                            :valueID="crud.form.methods_payment_id"
                            :key="crud.form.methods_payment_id" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="priceList"
                            @select-object="loadPriceList($event)"
                            :valueID="crud.form.price_list_id"
                            :key="crud.form.price_list_id"
                            :where="conditionPriceListActive"
                            :disabled="crud.form.id>0" />
              </b-col>
              <b-col md="4" v-if="showShipping">
                <FindObject render="search"
                            type="suppliers"
                            @select-object="loadShipping($event)"
                            :where="conditionSuppliersShippingActive"
                            :valueID="crud.form.shipping_id"
                            tag="Transporte"
                            :key="crud.form.shipping_id"/>
              </b-col>

              <b-col md="4" v-if="parameters.haveReason">
                <FindObject render="search"
                            type="orders-reason"
                            @select-object="loadReason($event)"
                            :valueID="crud.form.reason_id"
                            tag="Motivos"
                            :key="crud.form.reason_id"
                            :where="conditionReason"
                            :disabled="crud.form.id>0" />
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Productos" icon="fa fa-qrcode" :before-change="orderValidDetailItems">
            <b-row>
              <b-col lg="12" md="12" sm="12">
                  <Detail :customer_id="crud.form.customers_id"
                          :price_list_id="crud.form.price_list_id"
                          :reason_id="crud.form.reason_id"
                          :disable-customer-price-list-fallback="crud.form.disable_customer_price_list_fallback"
                          @load-detail="crud.form.detail = $event"
                          :editPrice="editPrice"
                          :validStock="validStock"
                          :detailEdit="crud.form.detail"
                          :showDiscount="false"
                          :key="'detailOrder_'+itemDetailForceUpdate"
                          :forceUpdate="itemDetailForceUpdate"
                          :validItemDuplicated="!allowProductsDuplicates"
                          :getItemOnlyPublished="showItemOnlyPublished" />

                  <b-row class="pl-3 pr-3 pb-2 mt-2">
                    <b-col md="2" class="mb-2 mb-md-0">
                      <div class="crud-orders-stat">
                        <span class="crud-orders-stat__label">Items</span>
                        <span class="crud-orders-stat__value">{{this.getCantItemOrder}}</span>
                      </div>
                    </b-col>
                    <b-col md="6"></b-col>
                    <b-col md="4" v-if="getCurrencyOrder">
                      <div class="crud-orders-totals">
                        <div class="crud-orders-totals__row">
                          <span class="crud-orders-totals__label">Subtotal</span>
                          <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getSubTotalOrder)}}</span>
                        </div>
                        <div class="crud-orders-totals__row">
                          <span class="crud-orders-totals__label">{{ this.getTagDiscount }}</span>
                          <div class="crud-orders-totals__discount-group">
                            <div class="crud-orders-totals__discount">
                              <b-form-select
                                v-if="getValueDiscount && getValueDiscount.length"
                                v-model="crud.form.percentage_discount"
                                :options="getValueDiscount"
                                size="sm"
                                @input="validDiscounts()">
                              </b-form-select>
                              <b-form-input
                                v-if="!getValueDiscount || !getValueDiscount.length"
                                v-model="crud.form.percentage_discount"
                                type="number"
                                min="0"
                                max="100"
                                step="1"
                                size="sm"
                                @change="validDiscounts()"/>
                              <span class="crud-orders-totals__discount-suffix">%</span>
                            </div>
                            <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(crud.form.discounts_price)}}</span>
                          </div>
                        </div>
                        <div class="crud-orders-totals__row crud-orders-totals__row--total">
                          <span class="crud-orders-totals__label">Total</span>
                          <span class="crud-orders-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyOrder}).format(getTotalOrder)}}</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">
            <b-row>
              <b-col md="6">

                <div v-if="crud.form.customers">
                  <b-avatar :src="crud.form.customers.image"
                            v-if="crud.form.customers.image">
                  </b-avatar>
                  <b-avatar v-else
                            :text="avatarFromName(crud.form.customers.name).text"
                            :style="avatarFromName(crud.form.customers.name).style">
                  </b-avatar>
                  &nbsp;<b>{{crud.form.customers.name}}</b>

                  <span v-if="crud.form.customers.bcra_status">
                    <span v-if="crud.form.customers.bcra_status.situacion > situationCreditMax">
                      &nbsp;
                      <b-badge variant="danger" :id="'popover-situation-' + crud.form.id">
                        Sit {{crud.form.customers.bcra_status.situacion}}
                      </b-badge>
                      <b-popover :target="'popover-situation-' + crud.form.id" variant="danger" triggers="hover">
                        <template #title>Riesgo Creditício</template>
                        <div v-html="situationCreditMessage(crud.form)"></div>
                      </b-popover>
                    </span>
                  </span>

                  <AppIcon name="circle-fill" v-if="!crud.form.customers.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />

                  <div v-if="crud.form.customers" class="ml-3">
                    <div v-if="!crud.form.customers.email">
                      <AppIcon name="mail" /> &nbsp;&nbsp;
                      <b-badge variant="warning" class="badget-custom">No tiene un email asociado</b-badge>
                    </div>
                    <div v-else>
                      <AppIcon name="mail" /> &nbsp;&nbsp;
                      <b-link :href="'mailto:' + crud.form.customers.email">
                        {{ crud.form.customers.email }}
                      </b-link>
                    </div>
                  </div>

                  <div v-if="crud.form.customers.phone" class="ml-3">
                    <AppIcon name="call" /> &nbsp;&nbsp;
                    <b-link :href="'tel:' + crud.form.customers.phone">
                      {{ crud.form.customers.phone }}
                    </b-link>
                  </div>

                  <b-row v-if="crud.form.customers.observations || crud.form.customers.observations_delivery || crud.form.customers.observations_delivery_address">
                    <b-col>
                      <hr>
                    </b-col>
                  </b-row>

                  <b-row v-if="crud.form.customers.observations"  class="mt-2">
                    <b-col class="crud-orders-observations">
                      <b>Observaciones</b>
                      <br>
                      {{ crud.form.customers.observations }}
                    </b-col>
                  </b-row>
                  <b-row v-if="crud.form.customers.observations_delivery"  class="mt-2">
                    <b-col class="crud-orders-observations">
                      <b>Transporte</b>
                      <br>
                      {{ crud.form.customers.observations_delivery }}
                    </b-col>
                  </b-row>
                  <b-row v-if="crud.form.customers.observations_delivery_address" class="mt-2">
                    <b-col class="crud-orders-observations">
                      <b>Dirección de Entrega</b>
                      <br>
                      {{ crud.form.customers.observations_delivery_address }}
                    </b-col>
                  </b-row>
                </div>

                <b-row v-if="!crud.form.id">
                  <b-col md="12">
                    <hr class="mt-2 mb-2">
                  </b-col>
                  <b-col md="12">
                    <b-form-checkbox v-model="crud.form.send_notification_email_customer" switch class="mt-2 mb-4">
                      Enviar notificación por email al cliente
                    </b-form-checkbox>
                  </b-col>
                  <b-col md="12" v-if="crud.form.send_notification_email_customer">
                    <b-form-group label="Email Alternativo" description="Este email se agrega a la lista de receptores del cliente para este pedido">
                      <b-form-input type="text"
                                    size="sm"
                                    v-model="crud.form.email_alternative"
                                    lazy
                                    required
                                    placeholder="Ingresar un email alternativo">
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col md="6">
                <b-row>
                  <b-col md="12">
                    <b-form-group label="Observaciones">
                      <app-textarea
                        v-model="crud.form.observations"
                        placeholder="Ingresar las observaciones..."
                        rows="5"
                        max-rows="7"
                        lazy
                      ></app-textarea>
                    </b-form-group>
                  </b-col>

                  <b-col md="12" class="mt-2">
                    <b-form-group label="Observaciones Internas (No se muestra al cliente)">
                      <app-textarea
                        v-model="crud.form.observations_internal"
                        placeholder="Ingresar las observaciones internas..."
                        rows="5"
                        max-rows="7"
                        lazy
                      ></app-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </tab-content>

        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              size="xl"
              dialog-class="orders-detail-modal-dialog"
              :key="modal.detail._id"
              :id="modal.detail._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">
            {{this.modal.detail.title}}
            <b-badge v-if="itemSelected" :variant="itemSelected.is_retail ? 'secondary' : 'primary'" class="ml-1">
              {{ itemSelected.is_retail ? 'Minorista' : 'Mayorista' }}
            </b-badge>
          </h5>
        </div>

        <b-row>
          <b-col sm="12">

            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">

              <b-tab v-if="itemSelected">
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <div class="app-modal-detail-list">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">ID</span>
                    <span class="app-modal-detail-list__value"><b>#{{this.itemSelected.id}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales && itemSelected.points_sales.business">
                    <span class="app-modal-detail-list__label">Empresa</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.points_sales.business.reference}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales">
                    <span class="app-modal-detail-list__label">Número</span>
                    <span class="app-modal-detail-list__value"><b>PEDIDO {{this.itemSelected.points_sales.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.id.toString().padStart(8,'0')}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.nro_order_internal">
                    <span class="app-modal-detail-list__label">Numeración Interna</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning">
                      <b><AppIcon name="link-45deg" /> {{this.itemSelected.nro_order_internal}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date).format('DD MMMM YYYY')}} - {{moment(this.itemSelected.created_at).format('HH:mm')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.points_sales">
                    <span class="app-modal-detail-list__label">Punto de Venta</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.points_sales.point_sale}} - {{this.itemSelected.points_sales.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.customer">
                    <span class="app-modal-detail-list__label">Cliente</span>
                    <span class="app-modal-detail-list__value">
                      <u>{{this.itemSelected.customer.name}}</u>
                      <div v-if="itemSelected.customer.phone">
                        <AppIcon name="call" /> {{this.itemSelected.customer.phone}}
                      </div>
                      <div v-if="itemSelected.customer.email">
                        <AppIcon name="inbox" /> {{this.itemSelected.customer.email}}
                      </div>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.user">
                    <span class="app-modal-detail-list__label">Usuario</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.user.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.reason">
                    <span class="app-modal-detail-list__label">Motivo</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.reason.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.method_payment">
                    <span class="app-modal-detail-list__label">Método de Pago</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.method_payment.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.shipping">
                    <span class="app-modal-detail-list__label">Transporte</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.shipping.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Estado</span>
                    <span class="app-modal-detail-list__value">
                      <span v-html="getStatusName(itemSelected)"></span>
                      <span v-if="itemSelected.status_system_manufacture" style="font-size: 10px;" class="ml-1">
                        <span v-if="JSON.parse(itemSelected.status_system_manufacture).status == 'error'" class="text-danger">
                          <i>{{JSON.parse(itemSelected.status_system_manufacture).message}}</i>
                        </span>
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.status!='in_process'">
                    <span class="app-modal-detail-list__label">SubTotal</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.subtotalItemSelected)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="parseFloat(itemSelected.discounts_price)">
                    <span class="app-modal-detail-list__label">{{ this.getTagDiscount }}</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.discounts_price)}}
                      <span v-if="parseFloat(itemSelected.percentage_discount)>0">
                        ({{parseFloat(this.itemSelected.percentage_discount)}} %)
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.delivery_info">
                    <span class="app-modal-detail-list__label">Entrega</span>
                    <span class="app-modal-detail-list__value">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.delivery_price)}}
                      <div>{{this.itemSelected.delivery_info}}</div>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Total S/IVA</span>
                    <span class="app-modal-detail-list__value" :class="itemSelected.paid ? 'order-total-table-paid' : 'order-total-table-nopaid'">
                      <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.total)}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.status!='in_process'">
                    <span class="app-modal-detail-list__label">IVA</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.iva)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Total C/IVA</span>
                    <span class="app-modal-detail-list__value" :class="itemSelected.paid ? 'order-total-table-paid' : 'order-total-table-nopaid'">
                      <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.origin_currency_code}).format(this.itemSelected.totalIva)}}</b>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.street_address">
                    <span class="app-modal-detail-list__label">Dirección</span>
                    <span class="app-modal-detail-list__value">
                      {{this.itemSelected.street_address}} {{this.itemSelected.street_number}} {{this.itemSelected.apartament_floor}}
                      <br>
                      {{this.itemSelected.city}} ({{this.itemSelected.postal_code}}), {{this.itemSelected.province}}
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observation">
                    <span class="app-modal-detail-list__label">Observaciones Entrega</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observation}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations_internal">
                    <span class="app-modal-detail-list__label">Observaciones Internas</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observations_internal}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations_external">
                    <span class="app-modal-detail-list__label">Observaciones External</span>
                    <span class="app-modal-detail-list__value"><div v-html="itemSelected.observations_external"></div></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.paid_info">
                    <span class="app-modal-detail-list__label">Observaciones Pago</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.paid_info}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.delivery_code_tracking">
                    <span class="app-modal-detail-list__label">Observaciones Transporte</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.delivery_code_tracking}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.sale && itemSelected.sale.type_voucher && itemSelected.sale.point_sale">
                    <span class="app-modal-detail-list__label">Factura</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.sale.type_voucher.name + ' ' + this.itemSelected.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.sale.number.toString().padStart(8,'0')}}</b></span>
                  </div>
                </div>
              </b-tab>
              <b-tab v-if="hasConsumerData(itemSelected)">
                <template #title><AppIcon name="person-badge" class="mr-1" /> Consumidor Final</template>
                <div class="app-modal-detail-list">
                  <div class="app-modal-detail-list__row" v-for="item in getConsumerDetailRows(itemSelected)" :key="'consumer-row-' + item.key">
                    <span class="app-modal-detail-list__label">{{ item.label }}</span>
                    <span class="app-modal-detail-list__value">
                      <AppIcon name="call" v-if="item.key == 'phone'" />
                      {{ item.value }}
                    </span>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template #title><AppIcon name="list-ul" class="mr-1" /> Items</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetail.items"
                        :fields="tableDetail.fields"
                        v-if="tableDetail.items.length"
                        :key="itemDetailForceUpdate">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(code)="data">
                    <div v-html="getProductCode(data.item)"></div>
                  </template>

                  <template v-slot:cell(product)="data">
                    <div v-html="getProductName(data.item)"></div>
                  </template>

                  <template v-slot:cell(list)="data">
                    <span v-if="data.item.price_list">
                      {{data.item.price_list.reference}}
                    </span>
                    <span v-else>
                      <span v-if="itemSelected.price_list">
                        {{itemSelected.price_list.reference}}
                      </span>
                    </span>
                  </template>

                  <template v-slot:cell(quantity)="data">
                    <div  v-if="data.item.observations">

                        <div  :id="'tooltip-button-show-event-' + data.item.id"
                              class="text-info">
                          <b>{{data.item.quantity}}</b>
                          <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                        </div>

                        <b-tooltip  ref="tooltip"
                                    placement="left"
                                    :target="'tooltip-button-show-event-' + data.item.id">
                          <div v-html="getQuantityVariant(data.item)"></div>
                        </b-tooltip>

                    </div>
                    <div v-else>
                      {{data.item.quantity}}
                      <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                    </div>
                  </template>

                  <template v-slot:cell(unit_price)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.unit_price)}}
                    </div>
                  </template>

                  <template v-slot:cell(discount_percentage)="data">
                    <div v-if="data.item.status!='in_process' && data.item.discount_percentage && parseFloat(data.item.discount_percentage) > 0">
                      {{parseFloat(data.item.discount_percentage)}}%
                    </div>
                  </template>

                  <template v-slot:cell(total)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.total)}}
                    </div>
                  </template>

                  <template v-slot:cell(iva)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.amount_iva)}}
                    </div>
                  </template>

                  <template v-slot:cell(total_iva)="data">
                    <div v-if="data.item.status!='in_process'">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.origin_currency_code}).format(data.item.total_iva)}}
                    </div>
                  </template>

                   <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  :toggle-class="isMobileViewport ? 'app-table-action-toggle-mobile' : 'app-table-action-toggle'"
                                  class="app-table-action-dropdown">
                        <template #button-content>
                          <AppIcon name="more_vert" label="Acciones" />
                          <span v-if="isMobileViewport" class="ml-1">Opciones</span>
                        </template>

                        <b-dropdown-item @click="openChangeNameProduct(data.item)">
                          <AppIcon name="edit" /> Cambiar Nombre
                        </b-dropdown-item>
                      </b-dropdown>
                   </template>
                </b-table>
                <EmptyState v-else icon="list-ul" title="No se encontraron registros" />
              </b-tab>
              <b-tab v-if="itemSelected && itemSelected.attachments.length>0">
                <template #title><AppIcon name="paperclip" class="mr-1" /> Adjuntos</template>
                <b-list-group>
                  <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="item in itemSelected.attachments" :key="item.id">
                    <b-link :href="item.file" target="_blank">
                      {{item.name}}
                    </b-link>
                    <a href="javascript:void(0);" @click="deleteAttach(item)">
                      <b-badge variant="danger" pill title="Eliminar">
                        <AppIcon name="delete" />
                      </b-badge>
                    </a>
                  </b-list-group-item>
                </b-list-group>
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD TRACKING -->
      <b-modal v-model="modal.tracking.active"
              size="md">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="truck" /></span>
          <h5 class="app-modal-header__title">{{this.modal.tracking.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Enviar email de aviso al cliente">
              <b-form-checkbox v-model="crud.tracking.send_email" size="sm" switch></b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col lg="12" v-if="crud.tracking.send_email">
            <b-form-group label="Información Adicional" description="Puede agregar un mensaje personalizado (ej: link de seguimiento de transporte, horario de retiro en el local, etc). Este mensaje se incluirá en el email de aviso al cliente">
              <app-textarea
                v-model="crud.tracking.delivery_code_tracking"
                placeholder="Agregar información adicional en el aviso por email al cliente..."
                rows="3"
                max-rows="6"
              ></app-textarea>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.tracking.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveTracking()"><AppIcon name="save" class="mr-1" />Aceptar</b-button>
        </div>
      </b-modal>

      <!-- CRUD NRO ORDER INTERNAL -->
      <b-modal v-model="modal.nroInternal.active"
              size="md">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="link-45deg" /></span>
          <h5 class="app-modal-header__title">{{this.modal.nroInternal.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Número Interno" description="Se utiliza para vincular un pedido con un sistema externo">
              <b-form-input type="text"
                            v-model="crud.nroInternal.nro_order_internal"
                            placeholder="Ingresar número interno">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.nroInternal.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveNroOrderInternal()"><AppIcon name="save" class="mr-1" />Aceptar</b-button>
        </div>
      </b-modal>

      <!-- CRUD NAME PRODUCT -->
      <b-modal v-model="modal.product.active"
              size="md">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.product.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <b-form-group label="Nombre Producto">
              <b-form-input type="text"
                            v-model="crud.product.name"
                            placeholder="Ingresar nombre">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.product.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveChangeNameProduct()"><AppIcon name="save" class="mr-1" />Cambiar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Printer from '@/components/inc/printer/printer'
  import Detail from '@/components/inc/cpbtDetail/detailProducts'
  import Param from '@/config/parameters'
  import moment from 'moment'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import Metrics from '@/components/inc/metrics/metrics'
  import Function from '@/handler/funciones'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      FormWizard,
      TabContent,
      Detail,
      Printer,
      Metrics,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrders',
          elements: {
            deleteOrders: true,
          }
        },
        metricsActive: false,
        parameters: {
          haveNroInteral: Helper.hasParametersAccess(Param.P21),
          remitFromOrder: Helper.hasParametersAccess(Param.P26),
          remitFromSale: Helper.hasParametersAccess(Param.P27),
          multipleItems: Helper.hasParametersAccess(Param.P52),
          haveReason: Helper.hasParametersAccess(Param.P54),
        },
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSub : {
          items: [],
          fields: []
        },
        tableDetail : {
          items: [],
          fields: []
        },
        itemSelected: null,
        detailDrawer: false,
        filtersOpen: false,
        // Reactivo al viewport real (matchMedia), nunca un string fijo:
        // BootstrapVue apaga sticky-header si `stacked` está seteado a
        // cualquier valor truthy, incluso en desktop.
        isMobileViewport: false,
        crud: {
          form: {
            id: 0,
            date: '',
            observations: '',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            observations_internal: '',
            erp_points_sales_id: 0,
            erp_points_sales: null,
            price_list_id: 0,
            price_list: null,
            disable_customer_price_list_fallback: false,
            methods_payment_id: 0,
            methods_payment: null,
            detail: [],
            email_alternative: '',
            shipping_id: 0,
            shipping: null,
            discounts_price: 0,
            percentage_discount: 0,
            is_retail: false,
            send_notification_email_customer: true,
            reason: null,
            reason_id : 0,
          },
          status: {
            id: 0,
            status: '',
            old_status: '',
          },
          paid: {
            id: 0,
            paid: false,
            paid_info: '',
          },
          tracking: {
            order_id: 0,
            delivery_code_tracking: '',
            status:'in_transport',
            send_email: true
          },
          nroInternal: {
            id: 0,
            nro_order_internal: '',
          },
          product: {
            id: 0,
            name: '',
          },
          print: {
            reference: 'order',
            id: 0,
            key: 0,
          }
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          detail: {
            active: false,
            title: '',
          },
          paid: {
            active: false,
            title: '',
          },
          tracking: {
            active: false,
            title: '',
          },
          nroInternal: {
            active: false,
            title: '',
          },
          product: {
            active: false,
            title: '',
          }
        },
        arr: {
          orders: [],
          export: [],
          filters : {
            number: 0,
            customers: [],
            sellers: [],
            status: [],
            points_sales: [],
            remitted: [
              {code: true, label: 'Remitido'},
              {code: false, label: 'No Remitido'}
            ],
            invoiced: [
              {code: true, label: 'Facturado'},
              {code: false, label: 'Sin facturar'}
            ],
            reasons: [],
          },
        },
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          sellers: null,
          status: null,
          source: 'product',
          points_sales: null,
          remitted: null,
          invoiced: null,
          typeOperations: 'wholesaler',
          number: '',
          reason: null,
          show_total_iva: false,
        },
        showView: {
          wholesaler: false,
          retailer: false,
          viewActive: ''
        },
        itemDetailForceUpdate: 0,
        itemFilterForceUpdate: 0,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.deleteOrders = Helper.hasAccessElement(this.access, 'delete_orders')
      /* Fin configuracion */
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_orders') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadConfigurations()
      this.filterLoad()
      this.filterOrders()

      // Acción directa desde la paleta de comandos: abrir el alta al entrar.
      if (this.$route.query.new == '1') {
        this.add()
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.loadConfigurations()
      this.filterLoad()
      this.filterOrders()

      // Misma acción directa que en mounted(): si la pestaña ya estaba
      // montada (keep-alive), "mounted" no vuelve a correr y la paleta de
      // comandos no abriría nada sin este chequeo acá también.
      if (this.$route.query.new == '1') {
        this.add()
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }
    },
    computed: {
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentOrderIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevOrder() {
        return this.currentOrderIndex > 0
      },
      canGoNextOrder() {
        if(this.currentOrderIndex < 0) {
          return false
        }
        return this.currentOrderIndex < (this.table.items.length - 1)
      },

      // MODULES
      moduleSellersActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENDEDORES) {
            status = true
          }
        })
        return status
      },
      moduleReceiptsActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.RECIBOS_ERP) {
            status = true
          }
        })
        return status
      },
      moduleRemitsActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.REMITOS) {
            status = true
          }
        })
        return status
      },
      moduleSalesActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {
            status = true
          }
        })
        return status
      },

      // OTHERS
      subtotalItemSelected() {
        if(this.getAplicationDiscount) {
          if(this.itemSelected) {
            return parseFloat(this.itemSelected.total) - parseFloat(this.itemSelected.delivery_price)
          } else {
            return 0
          }
        } else {
          if(this.itemSelected) {
            return parseFloat(this.itemSelected.total) - parseFloat(this.itemSelected.delivery_price) + parseFloat(this.itemSelected.discounts_price)
          } else {
            return 0
          }
        }
      },
      situationCreditMax() {
        if(this.configurations) {
          return this.configurations[1].value_number;
        } else {
          return 0;
        }
      },

      // INTEGRATION SYSTEM MANUFACTURE
      getIntegrationManufactureSystem() {
        if(this.configurations) {
          return this.configurations[4].value_string;
        } else {
          return '';
        }
      },

      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive(){
        return [{field: 'active', condition: true}];
      },
      conditionSuppliersShippingActive(){
        var condition = []
        condition.push({field: 'active', condition: true})
        condition.push({field: 'shipping', condition: true})
        return condition;
      },
      conditionReason() {
        let condition = []
        if(this.crud.form.customers_id) {
          condition.push({field: 'customer', condition: this.crud.form.customers_id});
        }
        return condition
      },

      // DISCOUNTS
      getTagDiscount() {
        if(this.configurations && this.configurations[19].value_string) {
          return this.configurations[19].value_string
        } else {
          return 'Descuento'
        }
      },
      getValueDiscount(){
        if(this.configurations && this.configurations[20].value_string) {
          var value = JSON.parse(this.configurations[20].value_string)
          var arr = []
          value.forEach(element => {
            arr.push({
              value:element,
              text: element + ' %'
            })
          });
          return arr
        } else {
          return null
        }
      },
      getAplicationDiscount() {
        if(this.configurations) {
          if(this.configurations[21].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },

      // CONFIG DETAIL
      validStock() {
        if(this.configurations) {
          if(this.configurations[2].value_boolean == 1) {
            return false
          } else {
            return true
          }
        } else {
          return true;
        }
      },
      editPrice() {
        if(this.configurations) {
          if(this.configurations[3].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
      allowProductsDuplicates() {
        if(this.configurations) {
          if(this.configurations[16].value_boolean == 1) {
            return true
          } else {
            if(this.parameters.multipleItems) {
              return true
            } else {
              return false
            }
          }
        } else {
          if(this.parameters.multipleItems) {
            return true
          } else {
            return false
          }
        }
      },
      showItemOnlyPublished() {
        var status = this.crud.form.reason && this.crud.form.reason.only_published
        return status
      },

      // PRICES / CANT / CURRENCY
      getSubTotalOrder() {
        var price = 0
        if(this.crud.form.detail) {
          this.crud.form.detail.forEach(element => {
            price = price + parseFloat(element.quantity) * parseFloat(element.amount)
          })
        }
        return parseFloat(price)
      },
      getTotalOrder() {
        if(this.getAplicationDiscount) {
          return this.getSubTotalOrder
        } else {
          this.validDiscounts()
          var discounts_price = parseFloat(this.crud.form.discounts_price)

          return this.getSubTotalOrder - discounts_price
        }
      },
      getCantItemOrder() {
        var cant = this.crud.form.detail.length
        return parseFloat(cant)
      },
      getCurrencyOrder() {
        var currency = 'ARS'
        if(this.crud.form.price_list) {
          if(this.crud.form.price_list.currency) {
            currency = this.crud.form.price_list.currency.code
          }
        }
        return currency
      },

      // VALIDA TRANSPORTE
      showShipping() {
        if(this.configurations) {
          if(this.configurations[18].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
      validShipping() {
        if(this.configurations) {
          if(this.configurations[17].value_boolean == 1) {
            return true
          } else {
            return false
          }
        } else {
          return false;
        }
      },
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_orders', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Function.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el dropdown de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      // Resalta en la tabla la fila del registro que está abierto en el
      // drawer, para no perder la referencia visual mientras se navega con
      // los botones anterior/siguiente.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },

      // CONFIGURACION
      loadConfigurations() {
        var result = serviceAPI.obtenerConfiguracion()

        result.then((response) => {
          var data = response.data
          this.configurations = data

          this.setStatusAltFilter()
          this.loadRenderView()
          this.loadFieldTable()
        })
      },
      loadFieldTable () {
        // TABLE PEDIDOS
        this.table.fields = []
        this.table.fields.push({key: 'business', label: 'Empresa', class:"align-middle " + this.alignClass('text-left'), width:"60px"})
        this.table.fields.push({key: 'id', label: 'Comprobante', class:"align-middle " + this.alignClass('text-center'), width:"140px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-center'), width:"80px"})
        this.table.fields.push({key: 'customers_id', label: 'Cliente', class:"align-middle", width:"180px"})
        if(this.showView.viewActive == 'wholesaler') {
          if(this.moduleSellersActive){
            this.table.fields.push({key: 'sellers_id', label: 'Vend', class:"align-middle " + this.alignClass('text-center'), width:"50px"})
          }

          this.table.fields.push({key: 'staff_id', label: 'Staff', class:"align-middle " + this.alignClass('text-center'), width:"50px"})
        }
        if(this.filters.show_total_iva) {
          this.table.fields.push({key: 'total', label: 'Total C/IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        } else {
          this.table.fields.push({key: 'total', label: 'Total S/IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        }
        this.table.fields.push({key: 'status', label: 'Estado', class:"align-middle " + this.alignClass('text-center'), width:"110px"})

        if(this.parameters.haveReason) {
          this.table.fields.push({key: 'reason', label: 'Motivo', class:"align-middle " + this.alignClass('text-center'), width:"90px"})
        }

        if(this.showView.viewActive == 'wholesaler') {
          this.table.fields.push({key: 'status_system_manufacture', label: '', class:"align-middle " + this.alignClass('text-center'), width:"20px"})
        }

        if(this.showView.viewActive == 'retailer') {
          this.table.fields.push({key: 'paid_info', label: this.isMobileViewport ? 'Pago' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        }

        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})

        if(this.showView.viewActive == 'retailer') {
          this.table.fields.push({key: 'delivery_code_tracking', label: this.isMobileViewport ? 'Transporte' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        }

        this.table.fields.push({key: 'invoice', label: this.isMobileViewport ? 'Facturado' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"50px"})

        // TABLE DETALLE (drawer, siempre vertical: alineación fija a la izquierda,
        // el b-sidebar tiene un ancho fijo que no depende de isMobileViewport)
        this.tableSub.fields = []
        this.tableSub.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle text-left", width:"30%"})
        this.tableSub.fields.push({key: 'product', label: 'Producto', class:"align-middle text-left", width:"70%"})

        // TABLE DETALLE COMPLETO (modal de detalle, sí depende del ancho real de la ventana)
        this.tableDetail.fields = []
        this.tableDetail.fields.push({key: 'code', label: 'Código', class:"align-middle " + this.alignClass('text-left'), width:"70px"})
        this.tableDetail.fields.push({key: 'product', label: 'Producto', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"220px"})
        this.tableDetail.fields.push({key: 'list', label: 'Lista', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"60px"})
        this.tableDetail.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'unit_price', label: 'P.Unit', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'discount_percentage', label: 'Desc. %', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'total', label: 'Total S/IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'iva', label: 'IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'total_iva', label: 'Total C/IVA', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.tableDetail.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class:"align-middle " + this.alignClass('text-right'), width:"50px"})
      },
      loadRenderView() {
        this.showView.wholesaler = (this.configurations[14].value_string == 'wholesaler' || this.configurations[14].value_string == 'both')
        this.showView.retailer = (this.configurations[14].value_string == 'retailer' || this.configurations[14].value_string == 'both')

        if(this.showView.wholesaler && this.showView.retailer) {
          this.showView.viewActive = 'wholesaler'
          this.filters.typeOperations = 'wholesaler'
        } else {
          if(this.showView.wholesaler) {
            this.showView.viewActive = 'wholesaler'
            this.filters.typeOperations = 'wholesaler'
          }
          if(this.showView.retailer) {
            this.showView.viewActive = 'retailer'
            this.filters.typeOperations = 'retailer'
          }
        }

      },
      getRowCount (items) {
        return items.length
      },
      tryParseConsumerJson(raw) {
        if(!raw) {
          return null
        }
        try {
          var parsed = JSON.parse(raw)
          if(parsed && typeof parsed === 'object') {
            return parsed
          }
          if(typeof parsed === 'string' && parsed.trim()) {
            return this.tryParseConsumerJson(parsed.trim())
          }
          return null
        } catch (error) {
          return null
        }
      },
      extractConsumerFromBrokenText(raw) {
        if(!raw) {
          return null
        }

        var base = String(raw || '').trim()
        if(!base) {
          return null
        }

        var decodedHtml = base
        if(typeof document !== 'undefined' && document.createElement) {
          var txt = document.createElement('textarea')
          txt.innerHTML = base
          decodedHtml = txt.value || base
        }

        var candidates = [
          base,
          decodedHtml,
          decodedHtml
            .replace(/\\"/g, '"')
            .replace(/\\n/g, '\n')
            .replace(/\\r/g, '\r')
            .replace(/\\t/g, '\t')
            .replace(/\\\\/g, '\\'),
        ]

        for(var i = 0; i < candidates.length; i++) {
          var text = String(candidates[i] || '').trim()
          if(!text) {
            continue
          }

          text = text.replace(/^\s*['"]+/, '').replace(/['"]+\s*$/, '')
          if(text.startsWith('{')) {
            text = text.slice(1)
          }
          if(text.endsWith('}')) {
            text = text.slice(0, -1)
          }

          var data = {}
          var count = 0
          var reQuoted = /"([^"]+)"\s*:\s*"([^"]*)/g
          var matchQuoted = null
          while((matchQuoted = reQuoted.exec(text)) !== null) {
            var keyQuoted = String(matchQuoted[1] || '').trim()
            var valueQuoted = String(matchQuoted[2] || '').trim()
            if(keyQuoted) {
              data[keyQuoted] = valueQuoted
              count += 1
            }
          }

          var reSimple = /"([^"]+)"\s*:\s*([^,}]+)/g
          var matchSimple = null
          while((matchSimple = reSimple.exec(text)) !== null) {
            var keySimple = String(matchSimple[1] || '').trim()
            var valueSimple = String(matchSimple[2] || '').trim().replace(/^['"]|['"]$/g, '')
            if(keySimple && !data[keySimple]) {
              data[keySimple] = valueSimple
              count += 1
            }
          }

          if(count > 0) {
            return data
          }
        }

        return null
      },
      parseConsumerData(value) {
        if(!value) {
          return null
        }

        if(typeof value === 'object') {
          return value
        }

        var raw = String(value).trim()
        if(!raw) {
          return null
        }

        var data = this.tryParseConsumerJson(raw)
        if(data) {
          return data
        }

        // Fallback: a veces llega escapado o con comillas externas.
        var unquoted = raw
        if((raw.startsWith('"') && raw.endsWith('"')) || (raw.startsWith("'") && raw.endsWith("'"))) {
          unquoted = raw.slice(1, -1)
          data = this.tryParseConsumerJson(unquoted)
          if(data) {
            return data
          }
        }

        var unescaped = unquoted
          .replace(/\\"/g, '"')
          .replace(/\\n/g, '\n')
          .replace(/\\r/g, '\r')
          .replace(/\\t/g, '\t')
          .replace(/\\\\/g, '\\')

        data = this.tryParseConsumerJson(unescaped)
        if(data) {
          return data
        }

        if(typeof document !== 'undefined' && document.createElement) {
          var txt = document.createElement('textarea')
          txt.innerHTML = raw
          var decoded = txt.value
          if(decoded && decoded !== raw) {
            data = this.tryParseConsumerJson(decoded)
            if(data) {
              return data
            }
          }
        }

        data = this.extractConsumerFromBrokenText(raw)
        if(data) {
          return data
        }

        return {
          raw_text: raw,
        }
      },
      hasConsumerData(order) {
        if(!order) {
          return false
        }
        return !!this.parseConsumerData(order.consumer)
      },
      getConsumerTriggerLabel(order) {
        var rows = this.getConsumerDetailRows(order)
        if(!rows.length) {
          return 'CF'
        }
        var firstValue = this.normalizeConsumerValue(rows[0].value)
        if(firstValue) {
          return firstValue
        }
        return rows[0].label || 'CF'
      },
      normalizeConsumerValue(value) {
        if(value === null || value === undefined) {
          return ''
        }
        if(typeof value === 'string') {
          return value.trim()
        }
        if(typeof value === 'number' || typeof value === 'boolean') {
          return String(value)
        }
        try {
          return JSON.stringify(value, null, 2)
        } catch (error) {
          return ''
        }
      },
      formatConsumerKey(key) {
        var map = {
          full_name: 'Nombre y Apellido',
          name: 'Nombre',
          lastname: 'Apellido',
          phone: 'Teléfono',
          email: 'Email',
          address: 'Dirección',
          city: 'Ciudad',
          province: 'Provincia',
          observations: 'Observaciones',
          raw_text: 'Dato sin formato',
        }
        if(map[key]) {
          return map[key]
        }
        return String(key || '')
          .replace(/_/g, ' ')
          .replace(/\b\w/g, function(char){ return char.toUpperCase() })
      },
      getConsumerDetailRows(order) {
        var consumer = this.parseConsumerData(order ? order.consumer : null)
        if(!consumer) {
          return []
        }

        var rows = []
        var usedKeys = {}
        var preferredKeys = ['name', 'lastname', 'phone', 'email', 'address', 'city', 'province', 'observations']

        var fullName = [this.normalizeConsumerValue(consumer.name), this.normalizeConsumerValue(consumer.lastname)]
          .filter(Boolean)
          .join(' ')
          .trim()
        if(fullName) {
          rows.push({
            key: 'full_name',
            label: this.formatConsumerKey('full_name'),
            value: fullName,
          })
          usedKeys.name = true
          usedKeys.lastname = true
        }

        preferredKeys.forEach((key) => {
          if(usedKeys[key]) {
            return
          }
          var value = this.normalizeConsumerValue(consumer[key])
          if(value) {
            rows.push({
              key: key,
              label: this.formatConsumerKey(key),
              value: value,
            })
            usedKeys[key] = true
          }
        })

        Object.keys(consumer).forEach((key) => {
          if(usedKeys[key]) {
            return
          }
          var value = this.normalizeConsumerValue(consumer[key])
          if(value) {
            rows.push({
              key: key,
              label: this.formatConsumerKey(key),
              value: value,
            })
          }
        })

        return rows
      },

      // RENDER
      selectRenderView(ref) {
        this.showView.viewActive = ref
        this.filters.typeOperations = ref
        this.loadFieldTable()
        this.filterOrders()
      },
      showGenerateRemits(item) {
        var status = false
        if(this.parameters.remitFromOrder) {
          if(!item.sale_id && !item.remitted && item.status=='pending_shipping' && this.moduleRemitsActive) {
            status = true
          }
        }
        return status
      },
      showGenerateInvoice(item) {
        var status = false
        if(!this.moduleRemitsActive || !this.parameters.remitFromOrder) {
          if(!item.sale_id && !item.remitted && item.status!='in_process' && this.moduleSalesActive) {
            status = true
          }
        }
        return status
      },

      // SELECT
      loadCustomers (object) {
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id

          if(!this.crud.form.observations && !this.crud.form.id) {
            if(object.observations_delivery_address) {
              this.crud.form.observations = 'ENTREGA: ' + object.observations_delivery_address
            }
          }

          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.erp_points_sales_id) {
                this.crud.form.erp_points_sales = object.data_fiscal.points_sales
                this.crud.form.erp_points_sales_id = object.data_fiscal.points_sales_id
              }
            }

            if(object.data_fiscal.methods_payment_id) {
              if(!this.crud.form.methods_payment_id) {
                this.crud.form.methods_payment = object.data_fiscal.methods_payment
                this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id
              }
            }

            if(object.data_fiscal.shipping_id) {
              if(!this.crud.form.shipping_id) {
                this.crud.form.shipping = object.data_fiscal.shipping
                this.crud.form.shipping_id = object.data_fiscal.shipping_id
              }
            }
          }

          if(!this.crud.form.price_list_id) {
            if(!this.crud.form.disable_customer_price_list_fallback && object.price_list) {
              if(object.price_list.list) {
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
                this.crud.form.disable_customer_price_list_fallback = false
              }
            }
          }

          if(this.parameters.haveReason) {
            this.crud.form.reason = null
            this.crud.form.reason_id = 0
          }
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.disable_customer_price_list_fallback = false
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.erp_points_sales = object
          this.crud.form.erp_points_sales_id = object.id
        } else {
          this.crud.form.erp_points_sales = null
          this.crud.form.erp_points_sales_id = 0
        }
      },
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id
          this.crud.form.disable_customer_price_list_fallback = false
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
          this.crud.form.disable_customer_price_list_fallback = true
        }

        this.detailForceUpdate()
      },
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadShipping (object) {
        if(object){
          this.crud.form.shipping = object
          this.crud.form.shipping_id = object.id
        } else {
          this.crud.form.shipping = null
          this.crud.form.shipping_id = 0
        }
      },
      loadReason (object) {
        if(object){
          this.crud.form.reason = object
          this.crud.form.reason_id = object.id

          if(object && object.price_list_id && object.list) {
            this.crud.form.price_list = object.list
            this.crud.form.price_list_id = object.list.id
            this.crud.form.disable_customer_price_list_fallback = false
          } else {
            if(!this.crud.form.disable_customer_price_list_fallback &&
               this.crud.form.customers &&
               this.crud.form.customers.price_list &&
               this.crud.form.customers.price_list.list) {
              this.crud.form.price_list = this.crud.form.customers.price_list.list
              this.crud.form.price_list_id = this.crud.form.customers.price_list.list.id
              this.crud.form.disable_customer_price_list_fallback = false
            }
          }
        } else {
          this.crud.form.reason = null
          this.crud.form.reason_id = 0
        }

        this.detailForceUpdate()
      },
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var businessID = 0
          var businessName = ""
          var customersID = 0
          var customersCode = ""
          var customersName = ""
          var pointSalesCode = ""
          var pointSalesName = ""
          var methodsPaymentID = 0
          var methodsPaymentName = ""
          var shippingID = 0
          var shippingName = ""
          var reasonID = 0
          var reasonName = ""

          if(element.points_sales && element.points_sales.business) {
            businessID = element.points_sales.business.id
            businessName = element.points_sales.business.reference
          }

          if(element.customer) {
            customersID = element.customer.id
            customersCode = element.customer.point_sale
            customersName = element.customer.name
          }

          if(element.points_sales) {
            pointSalesCode = element.points_sales.point_sale
            pointSalesName = element.points_sales.name
          }

          if(element.method_payment) {
            methodsPaymentID = element.method_payment.id
            methodsPaymentName = element.method_payment.name
          }

          if(element.shipping) {
            shippingID = element.shipping.id
            shippingName = element.shipping.name
          }

          if(element.reason) {
            reasonID = element.reason.id
            reasonName = element.reason.name
          }

          this.arr.export.push({
            id: element.id,
            businessID: businessID,
            businessName: businessName,
            pointSalesCode: pointSalesCode,
            pointSalesName: pointSalesName,
            date: element.date,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            methodsPaymentID: methodsPaymentID,
            methodsPaymentName: methodsPaymentName,
            shippingID: shippingID,
            shippingName: shippingName,
            reasonID: reasonID,
            reasonName: reasonName,
            discount: element.discounts_price.replace('.',','),
            percentage_discount: element.percentage_discount.replace('.',','),
            total: element.total.replace('.',','),
            status: this.getStatusAltByName(element),
            observations: element.observation,
            observations_external: element.observations_external,
            observations_internal: element.observations_internal,
            productID: 0,
            productCode: '',
            productName: '',
            priceListID: 0,
            priceListName: "",
            quantity: 0,
            unitMeasurementID: 0,
            unitMeasurementName: '',
            unit_price: 0,
            amount_total: 0,
          })

          element.details.forEach(element1 => {
            var productID = 0
            var productCode = ""
            var productName = ""
            var unitMeasurementID = 0
            var unitMeasurementName = ""
            var priceListID = 0
            var priceListName = ""

            if(element1.products_id && element1.product) {
              productID = element1.product.id
              productCode = element1.product.code
              productName = element1.product.name
            }

            if(element1.products_colors_id && element1.products_color) {
              productID = element1.products_color.id
              productCode = element1.products_color.code
              productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
            }

            if(element1.products_waist_id && element1.products_waist) {
              productID = element1.products_waist.id
              productCode = element1.products_waist.code
              productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
            }

            if(element1.products_color_waist_id && element1.products_color_waist) {
              productID = element1.products_color_waist.id
              productCode = element1.products_color_waist.code
              productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
            }

            if(element1.unit_measurement_id && element1.unit_measurement) {
              unitMeasurementID = element1.unit_measurement.id
              unitMeasurementName = element1.unit_measurement.name
            }

            if(element1.price_list_id && element1.price_list) {
              priceListID = element1.price_list.id
              priceListName = element1.price_list.name
            } else {
              if(element.price_list_id && element.price_list) {
                priceListID = element.price_list.id
                priceListName = element.price_list.name
              }
            }

            this.arr.export.push({
              productID: productID,
              productCode: productCode,
              productName: productName,
              priceListID: priceListID,
              priceListName: priceListName,
              quantity: element1.quantity.replace('.',','),
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,
              unit_price: element1.unit_price.replace('.',','),
              amount_total: element1.total.replace('.',','),
            })
          })
        });
      },

      // ABM MAIN
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.observations_internal = ''
        this.crud.form.erp_points_sales_id = 0
        this.crud.form.erp_points_sales = null
        this.crud.form.methods_payment_id = 0
        this.crud.form.methods_payment = null
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null
        this.crud.form.disable_customer_price_list_fallback = false
        this.crud.form.detail = []
        this.crud.form.email_alternative = ''
        this.crud.form.shipping_id = 0
        this.crud.form.shipping = null
        this.crud.form.discounts_price = 0
        this.crud.form.percentage_discount = 0
        this.crud.form.is_retail = false
        this.crud.form.send_notification_email_customer = true
        this.crud.form.reason_id = 0
        this.crud.form.reason = null

        this.detailForceUpdate()

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Pedido"
        this.modal.form.active = true
      },
      edit(item) {
        let loader = this.$loading.show();

        this.crud.form.id = item.id
        this.crud.form.date = moment(item.date).format('YYYY-MM-DD')
        this.crud.form.observations = item.observation
        this.crud.form.staff_id = (item.staff_id) ? item.staff_id : Helper.getStaffId()
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.observations_internal = item.observations_internal
        this.crud.form.erp_points_sales_id = item.erp_points_sales_id
        this.crud.form.erp_points_sales = item.points_sales
        this.crud.form.methods_payment_id = item.methods_payment_id
        this.crud.form.methods_payment = item.method_payment
        this.crud.form.price_list_id = item.price_list_id
        this.crud.form.price_list = item.price_list
        this.crud.form.disable_customer_price_list_fallback = !item.price_list_id
        this.crud.form.email_alternative = item.email_alternative
        this.crud.form.shipping_id = item.shipping_id
        this.crud.form.shipping = item.shipping
        this.crud.form.discounts_price = parseFloat(item.discounts_price)
        this.crud.form.percentage_discount = parseFloat(item.percentage_discount)
        this.crud.form.is_retail = item.is_retail
        this.crud.form.send_notification_email_customer = true
        this.crud.form.reason_id = item.reason_id
        this.crud.form.reason = item.reason

        this.detailForceUpdate()

        var result = serviceAPI.mostrarPedido(item.id);

        result.then((response) => {
          var data = response.data
          this.crud.form.detail = data.detail

          // recalculo el % si no se guardo
          if(parseFloat(item.discounts_price) && !parseFloat(item.percentage_discount)) {
            this.crud.form.percentage_discount = this.getSubTotalOrder / item.discounts_price
          }

          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.title = 'PEDIDO ' + this.crud.form.erp_points_sales.point_sale.toString().padStart(4,'0') + '-' + this.crud.form.id.toString().padStart(8,'0')
          this.modal.form.active = true
          loader.hide()
        })
        .catch(error => {
          // Una demora/error del detalle no debe dejar la vista bloqueada con el loader.
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },
      remove(item) {
        this.crud.form.id = item.id

        this.confirmDialog('¿Desea borrar el pedido #' + this.crud.form.id + '?', {
          title: 'Borrar Pedido',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarPedido(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              if(this.itemSelected && this.itemSelected.id === this.crud.form.id) {
                this.hideSub()
              }
              loader.hide()
              this.filterOrders()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        if(!this.crud.form.erp_points_sales_id) {
          this.$awn.alert('Falta cargar el punto de venta')
          return false
        }

        this.confirmDialog('¿Desea continuar con la generación del pedido?', {
          title: 'Generar Pedido',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            if (this.crud.form.id) {
              var result = serviceAPI.editarPedido(this.crud.form);
            } else {
              var result = serviceAPI.agregarPedido(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterOrders()
              this.$awn.success("Pedido generado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el pedido?', {
          title: 'Cancelar el Pedido',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      orderValidDetailGeneral() {
        var valid = this.crud.form.customers_id && this.crud.form.erp_points_sales_id && this.crud.form.methods_payment_id

        if(this.validShipping) {
          valid = valid && this.crud.form.shipping_id
        }

        if(this.parameters.haveReason) {
          valid = valid && this.crud.form.reason_id
        }

        if(valid) {
          return true;
        } else {
          if(!this.crud.form.customers_id) {
            this.$awn.alert("No se cargó el cliente");
            return false;
          }
          if(!this.crud.form.erp_points_sales_id) {
            this.$awn.alert("No se cargó el punto de venta");
            return false;
          }
          if(!this.crud.form.methods_payment_id) {
            this.$awn.alert("No se cargó el método de pago");
            return false;
          }
          if(this.validShipping) {
            if(!this.crud.form.shipping_id) {
              this.$awn.alert("No se cargó el transporte");
              return false;
            }
          }
          if(this.parameters.haveReason) {
            if(!this.crud.form.reason_id) {
              this.$awn.alert("No se cargó el motivo");
              return false;
            }
          }
        }
      },
      orderValidDetailItems() {
        if(this.crud.form.detail.length) {
          return true;
        } else {
          this.$awn.alert("No se cargó ningún item");
          return false;
        }
      },
      detailForceUpdate() {
        this.itemDetailForceUpdate = this.itemDetailForceUpdate + 1
      },
      filterForceUpdate() {
        this.itemFilterForceUpdate = this.itemFilterForceUpdate + 1
      },

      // DISCOUNTS
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {
          this.crud.form.percentage_discount = 0
        } else {
          if( parseFloat(this.crud.form.percentage_discount) < 0 ||
              parseFloat(this.crud.form.percentage_discount) > 100 ) {
            this.crud.form.percentage_discount = 0
          }
        }

        var percentage = parseFloat(this.crud.form.percentage_discount)
        this.crud.form.discounts_price = (this.getSubTotalOrder * percentage) / 100
      },

      // FILTER
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadSellers()
        this.filterLoadPointSale()
        this.filterLoadReasons()
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.filters.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
        if(!this.moduleSalesActive) {
          this.filters.invoiced = null
        }
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()
        result.then((response) => {
          var data = response.data

          this.arr.filters.customers = []
          data.forEach(element => {
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })
            }
          });
        })
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()
        result.then((response) => {
          var data = response.data

          this.arr.filters.sellers = []
          data.forEach(element => {
            this.arr.filters.sellers.push({ code: element.id, label: element.name })
          });
        })
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()
        result.then((response) => {
          var data = response.data

          this.arr.filters.points_sales = []
          data.forEach(element => {
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })
          });
        })
      },
      filterLoadReasons() {
        var result = serviceAPI.obtenerMotivos()
        result.then((response) => {
          var data = response.data

          this.arr.filters.reasons = []
          data.forEach(element => {
            this.arr.filters.reasons.push({ code: element.id, label: element.name })
          });
        })
      },
      filterOrders(forceOpenSub=false, forceOpenDetail=false) {
        this.saveFilterStorage()
        this.table.isBusy = true
        const selectedOrderId = forceOpenSub && this.itemSelected ? this.itemSelected.id : null
        var result = serviceAPI.filtrarPedido(this.filters, this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data
          this.table.items = data.data
          this.arr.orders = data.data
          this.prepareExport(data.data)

          this.table.items.forEach(element => {
            if(element.status == 'cancel') {
              element._rowVariant = 'danger'
            }

            if(selectedOrderId) {
              if(element.id == selectedOrderId) {
                this.openSub(element)

                if(forceOpenDetail) {
                  this.openDetail()
                  this.detailForceUpdate()
                }
              }
            }
          });

          // Si el nuevo estado ya no coincide con los filtros activos, el
          // pedido deja de estar en la grilla y no debe quedar información
          // vieja abierta en el sidebar.
          if(selectedOrderId && !this.table.items.some(element => element.id == selectedOrderId)) {
            this.hideSub()
          }

          this.loadFieldTable()

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })
      },
      refreshOrdersAfterMutation() {
        this.filterOrders(!!(this.detailDrawer && this.itemSelected))
      },
      filterOrdersMetrics() {
        this.filterForceUpdate()
      },

      // ORDER DETAIL
      openSub(item) {
        this.itemSelected = item

        this.tableSub.items = item.details
        this.detailDrawer = true
      },
      hideSub() {
        this.tableSub.items=[]
        this.itemSelected = null
        this.detailDrawer = false
      },
      // Anterior/siguiente desde el drawer: reusa openSub() con el vecino,
      // así el contenido y el resaltado de fila se actualizan por el mismo
      // camino que un click directo en la tabla.
      goPrevOrder() {
        if(!this.canGoPrevOrder) return
        var item = this.table.items[this.currentOrderIndex - 1]
        if(item) this.openSub(item)
      },
      goNextOrder() {
        if(!this.canGoNextOrder) return
        var item = this.table.items[this.currentOrderIndex + 1]
        if(item) this.openSub(item)
      },
      openDetail() {
        this.tableDetail.items = this.itemSelected.details

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle del Pedido"
        this.modal.detail.active = true
      },
      getProductCode(item) {
        var code = ''
        var prod = null

        if(item.code) {
          code = item.code
        }

        if(item.products_id) {
          if(code) {
            return code
          } else {
            return item.product.code
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }
      },
      getProductName(item) {
        var name = ''
        var prod = null

        if(item.description) {
          name = item.description
        }

        if(item.products_id) {
          if(name) {
            return name
          } else {
            return item.product.name
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(name) {
            return name + ' (' + prod.color.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ')'
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(name) {
            return name + ' (' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.waist.name + ')'
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(name) {
            return name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          }
        }
      },
      getQuantityVariant(item) {
        var html = ''
        if(item.observations) {
          var variants = JSON.parse(item.observations)
          variants.forEach((element, index) => {
            var name = element[0]
            var cant = element[1]
            if(parseFloat(cant)>0) {
              html = html + '<i class="fa fa-circle" style="font-size:8px;"></i> ' + name + '- (<b>' + cant + '</b>)<br>'
            }
          });
        }
        return html
      },
      getInvoiceTitle(item) {
        if(!item || !item.sale || !item.sale.type_voucher || !item.sale.point_sale) {
          return ''
        }

        var title = item.sale.type_voucher.name + ' ' + item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.sale.number.toString().padStart(8,'0')
        if(item.sale.date) {
          title = title + ' | ' + moment(item.sale.date).format('DD/MM/YYYY')
        }

        return title
      },

      // STATUS ALTERNTIVOS
      getStatusName(item) {
        var name = ''
        var background = 'black'
        var arrStatus = item.status_alt

        switch (item.status) {
          case 'in_process':
            name = arrStatus[0]
            background = '#c1bb00'
            break;

          case 'closed':
            name = arrStatus[1]
            background = '#1a85e0'
            break;

          case 'in_preparation':
            name = arrStatus[2]
            background = '#582eda'
            break;

          case 'pending_shipping':
            name = arrStatus[3]
            background = '#ce7910'
            break;

          case 'in_transport':
            name = arrStatus[4]
            background = '#33bf8c'
            break;

          case 'delivered':
            name = arrStatus[5]
            background = '#3e9619'
            break;

          case 'cancel':
            name = arrStatus[6]
            background = '#d23829'
            break;
        }

        // system manufacture status
        if(item.status_system_manufacture && this.configurations) {
          if(JSON.parse(item.status_system_manufacture).status == 'ok') {
            name = this.configurations[11].value_string
            background = '#c72eda'
          }
          if(JSON.parse(item.status_system_manufacture).status == 'error') {
            name = this.configurations[12].value_string
            background = '#ff1f1f'
          }
        }
        // fin

        return '<span style="background-color:' + background + '; color: #fff; font-size:12px; font-weight:700; padding: 2px;">'+ name +"</span>"
      },
      setStatusAltFilter() {
        var arrStatus = this.configurations[9].value_string.split(',')
        var haveSystemManufacture = this.configurations[4].value_string
        var showStatusInProcess = this.configurations[13].value_boolean

        this.arr.filters.status = []

        if(showStatusInProcess) {
          if(arrStatus[0])
            this.arr.filters.status.push({code:'in_process', label: arrStatus[0]})
        }

        if(arrStatus[1])
          this.arr.filters.status.push({code:'closed', label: arrStatus[1]})

        if(haveSystemManufacture) {
          this.arr.filters.status.push({code:'pending_manufacture', label: this.configurations[11].value_string})
          this.arr.filters.status.push({code:'error_manufacture', label: this.configurations[12].value_string})
        }

        if(arrStatus[2])
          this.arr.filters.status.push({code:'in_preparation', label: arrStatus[2]})

        if(arrStatus[3])
          this.arr.filters.status.push({code:'pending_shipping', label: arrStatus[3]})

        if(arrStatus[4])
          this.arr.filters.status.push({code:'in_transport', label: arrStatus[4]})

        if(arrStatus[5])
          this.arr.filters.status.push({code:'delivered', label: arrStatus[5]})

        if(arrStatus[6])
          this.arr.filters.status.push({code:'cancel', label: arrStatus[6]})
      },
      getStatusAltByName(item) {
        var name = ''
        var arrStatus = item.status_alt

        switch (item.status) {
          case 'in_process':
            name = arrStatus[0]
            break;

          case 'closed':
            name = arrStatus[1]
            break;

          case 'in_preparation':
            name = arrStatus[2]
            break;

          case 'pending_shipping':
            name = arrStatus[3]
            break;

          case 'in_transport':
            name = arrStatus[4]
            break;

          case 'delivered':
            name = arrStatus[5]
            break;

          case 'cancel':
            name = arrStatus[6]
            break;
        }

        // system manufacture status
        if(item.status_system_manufacture && this.configurations) {
          if(JSON.parse(item.status_system_manufacture).status == 'ok') {
            name = this.configurations[11].value_string
          }
          if(JSON.parse(item.status_system_manufacture).status == 'error') {
            name = this.configurations[12].value_string
          }
        }
        // fin

        return name
      },

      // STATUS
      nextStatus(item){
        var nextStatus = 'closed'
        switch (item.status) {
          case 'closed':
            nextStatus = 'in_preparation'
            break;

          case 'in_preparation':
            nextStatus = 'pending_shipping'
            break;

          case 'pending_shipping':
            nextStatus = 'in_transport'
            break;

          case 'in_transport':
            nextStatus = 'delivered'
            break;
        }

        // si el proximo estado es "en transporte"
        // se abre un proceso propio para trabajar este paso de estado
        if(nextStatus=='in_transport') {
          this.openTracking(item)
          return false
        }

        // si tiene una url para integracion, desde el estado 'closed' al 'in_preparation'
        // se vincula con el sistema de fabricacion
        if(this.getIntegrationManufactureSystem) {
          if(nextStatus=='in_preparation') {
            this.integratedManufactureSystem(item)
            return false
          }
        }

        let loader = this.$loading.show();

        this.crud.status.id = item.id
        this.crud.status.status = nextStatus
        this.crud.status.old_status = item.status
        var result = serviceAPI.cambiarEstadoPedido(this.crud.status, true);

        result.then((response) => {
          loader.hide()
          this.refreshOrdersAfterMutation()
          this.$awn.success("Estado cambiado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      showNextStatus(item){
        if(this.getIntegrationManufactureSystem) {
          if(item.status == 'in_preparation') {
            return false
          }
        }

        if(item.status == 'in_process' || item.status == 'delivered' || item.status == 'cancel') {
          return false
        } else {
          return true
        }
      },
      previousStatus(item){
        var nextStatus = 'delivered'
        switch (item.status) {
          case 'delivered':
            nextStatus = 'in_transport'
            break;

          case 'in_transport':
            nextStatus = 'pending_shipping'
            break;

          case 'pending_shipping':
            nextStatus = 'in_preparation'
            break;

          case 'in_preparation':
            nextStatus = 'closed'
            break;
        }

        let loader = this.$loading.show();

        this.crud.status.id = item.id
        this.crud.status.status = nextStatus
        this.crud.status.old_status = item.status
        var result = serviceAPI.cambiarEstadoPedido(this.crud.status, true);

        result.then((response) => {
          loader.hide()
          this.refreshOrdersAfterMutation()
          this.$awn.success("Estado cambiado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      showPreviousStatus(item){
        if(this.getIntegrationManufactureSystem) {
          if(item.status == 'in_preparation' || item.status == 'pending_shipping') {
            return false
          }
        }

        if(item.status == 'in_process' || item.status == 'closed' || item.status == 'cancel') {
          return false
        } else {
          return true
        }
      },
      cancelStatus(item){
        this.confirmDialog('¿Desea cancelar el pedido #' + item.id + '?', {
          title: 'Cancelar el Pedido',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            this.crud.status.id = item.id
            this.crud.status.status = 'cancel'
            var result = serviceAPI.cambiarEstadoPedido(this.crud.status, true);

            result.then((response) => {
              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.success("Pedido cancelado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      showCancelStatus(item){
        if(this.getIntegrationManufactureSystem) {
          return false
        }

        if(item.status!='cancel') {
          return true
        } else {
          return false
        }
      },
      closedStatus(item){
        this.confirmDialog('¿Desea restaurar el pedido #' + item.id + '?', {
          title: 'Restaurar el Pedido',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            this.crud.status.id = item.id
            this.crud.status.status = 'closed'
            var result = serviceAPI.cambiarEstadoPedido(this.crud.status, true);

            result.then((response) => {
              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.success("Pedido restaurado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      showRestoreStatus(item){
        if(this.getIntegrationManufactureSystem) {
          return false
        }

        if(item.status=='cancel') {
          return true
        } else {
          return false
        }
      },

      // PAY
      showPaid(item) {
        if(item.status=='in_process') {
          return false
        } else {
          if(item.paid) {
            return false
          } else {
            return true
          }
        }
      },
      showCancelPaid(item) {
        if(item.status=='in_process') {
          return false
        } else {
          if(item.paid) {
            return true
          } else {
            return false
          }
        }
      },
      changePaid(item) {
        var msj = ''
        if(item.paid) {
          msj = '¿Continuar con la cancelación del pago del pedido #' + item.id + '?'
        } else {
          msj = '¿Desea forzar el pago del pedido #' + item.id + '?'
        }

        this.confirmDialog(msj, {
          title: 'Estado Pago',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            this.crud.paid.id = item.id

            if(item.paid) {
              this.crud.paid.paid = false
              this.crud.paid.paid_info = 'Se forzó la cancelación del pago desde el sistema'
            } else {
              this.crud.paid.paid = true
              this.crud.paid.paid_info = 'Se forzó el pago desde el sistema'
            }

            var result = serviceAPI.cambiarPago(this.crud.paid, true);

            result.then((response) => {
              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.success("Pago forzado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      getLinkPay(item) {
        this.confirmDialog('¿Desea obtener el link de pago?', {
          title: 'Link de Pago',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.getLinkPago({
              id: item.id,
            });

            result.then((response) => {
              loader.hide()

              var link = response.data

              this.copyLinkPay(link)
              window.open(link,
                "Pagar",
                "toolbar=no," +
                "scrollbars=no," +
                "location=no," +
                "statusbar=no," +
                "menubar=no," +
                "resizable=0," +
                "width=1000," +
                "height=800," +
                "left=300," +
                "top=100"
              );
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      copyLinkPay(text) {
        var divContainer = document.getElementById("link_container");
        var divLink = document.createElement("div");
        divLink.setAttribute("id", 'link_suscription');
        divLink.textContent = text;
        divContainer.appendChild(divLink);

        var codigoACopiar = document.getElementById('link_suscription')
        var seleccion = document.createRange();
        seleccion.selectNodeContents(codigoACopiar);

        window.getSelection().removeAllRanges();
        window.getSelection().addRange(seleccion);


        var res = document.execCommand('copy');
        if (res){
          this.$awn.success("Link de Pago copiado en portapapeles");
        } else {
          this.$awn.alert("No se pudo copiar el Link de Pago");
        }

        divLink.remove()
      },

      // DELIVERY
      openTracking(item) {
        this.crud.tracking.order_id = item.id
        this.crud.tracking.delivery_code_tracking = ''
        this.crud.tracking.status = 'in_transport'
        this.crud.tracking.send_email = true

        this.modal.tracking.title = "Transporte / Retiro"
        this.modal.tracking.active = true
      },
      saveTracking() {
        this.confirmDialog('¿Confirmar transporte del pedido #' + this.crud.tracking.order_id + '?', {
          title: 'Transporte',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.trackingPedido(this.crud.tracking, true);

            result.then((response) => {
              this.modal.tracking.active = false
              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.success("Pedido enviado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // INTEGRATION MANUFACTURE SYSTEM
      integratedManufactureSystem(item) {
        this.confirmDialog('¿Confirmar sincronización del pedido #' + item.id + '?', {
          title: 'Sincronización',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.integratedManufactureSystemPedido({
              url: this.configurations[4].value_string,
              data: item
            });

            result.then((response) => {
              var data = response.data
              serviceAPI.cambiarEstadoSistemaProduccion({
                id: item.id,
                status: 'ok',
                status_system_manufacture: data,
              }, true);

              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.success("Pedido sincronizado");
            })
            .catch(error => {
              serviceAPI.cambiarEstadoSistemaProduccion({
                id: item.id,
                status: 'error',
                status_system_manufacture: error.response.data,
              }, true);
              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.alert(Error.showError(error))
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // CREDIT SITUATION
      situationCreditMessage(item) {
        if(item.customer) {
          var message = "<b>Fecha:</b> "+ moment(item.customer.bcra_status.fecha).format('DD/MM/YYYY') +"<br><b>Situación:</b> "+ item.customer.bcra_status.situacion +"<br><b>Cheques Rechazados:</b> " + item.customer.bcra_status.rechazos
          return message;
        } else {
          return '';
        }
      },

      // NRO INTERNAL
      openNroOrderInternal(item) {
        this.crud.nroInternal.id = item.id
        this.crud.nroInternal.nro_order_internal = item.nro_order_internal

        this.modal.nroInternal.title = "Número Interno"
        this.modal.nroInternal.active = true
      },
      saveNroOrderInternal() {
        this.confirmDialog('¿Confirma el cambio?', {
          title: 'Agregar Número Interno',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.changeNroOrderInternal(this.crud.nroInternal, true);

            result.then((response) => {
              this.modal.nroInternal.active = false
              loader.hide()
              this.refreshOrdersAfterMutation()
              this.$awn.success("Se cambio el número interno con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // ADJUNTOS
      deleteAttach(item) {
        this.confirmDialog('¿Desea borrar el archivo adjunto [' + item.name + '] del pedido Nº: ' + item.order_id + '?', {
          title: 'Borrar Adjunto',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarAdjunto(item.id);

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterOrders(true, true)
              this.$awn.success("Adjunto eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // PROCESS ADMINISTRATIVE
      generateRemits(item) {
        this.$router.push({ name: 'RemitsStaffRemitsGenerateByOrders', params: {ordersID: item.id} })
      },
      generateInvoice(item) {
        this.$router.push({ name: 'SalesStaffSalesGenerateByOrders', params: {ordersID: item.id} })
      },

      // CHANGE PRODUCT NAME
      openChangeNameProduct(item) {
        this.crud.product.id = item.id
        this.crud.product.name = item.description

        this.modal.product.title = "Edición Nombre Producto"
        this.modal.product.active = true
      },
      saveChangeNameProduct() {
        this.confirmDialog('¿Cambiar nombre del producto?', {
          title: 'Nombre de Producto',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.changeNameProduct(this.crud.product);

            result.then((response) => {
              this.modal.product.active = false
              loader.hide()
              this.filterOrders(true, true)
              this.$awn.success("Se cambio el nombre del producto con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // SEND and PRINT
      sendEmailOrder(item) {
        this.confirmDialog('Está a punto de reenviar el email con el detalle del pedido Nº #' + item.id + '. ¿Desea continuar?', {
          title: 'Reenviar Email',
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.sendEmailOrder({id: item.id});

            result.then((response) => {
              loader.hide()
              this.$awn.success("Email Enviado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      sendPrinterOrder(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_crud_orders', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_crud_orders')) {
          this.filters = Object.assign({}, this.filters, JSON.parse(Storage.getValue('filter_crud_orders')))
        }
      },
    }
  }
</script>
<style>
  /* El dropdown de acciones es un <div> a nivel de bloque por defecto
     (Bootstrap no lo fuerza a inline): con "pull-right" (float) quedaba
     pegado arriba de la celda, ignorando el "align-middle" de la fila.
     Como inline-flex sigue participando de la caja de línea, respeta tanto
     el vertical-align:middle del <td> como su text-align (heredado del
     field, izquierda en mobile / derecha en desktop). */
  .app-table-action-dropdown {
    display: inline-flex !important;
    vertical-align: middle !important;
  }
  .app-table-action-toggle-mobile {
    display: inline-flex !important;
    align-items: center;
    width: auto !important;
    height: auto !important;
    justify-content: flex-start !important;
    padding: 4px 8px !important;
    font-size: 13px;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-orders-view-tabs .nav-link {
    padding: 8px 6px;
  }
  .crud-orders-view-tabs > .col-auto {
    padding-left: 2px;
    padding-right: 2px;
  }
  .crud-orders-wizard .wizard-header {
    padding: 0px;
  }
  .crud-orders-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-orders-wizard .wizard-card-footer .wizard-footer-left,
  .crud-orders-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-orders-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-orders-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn::before,
  .crud-orders-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-orders-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-orders-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-orders-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-orders-wizard .wizard-footer-left,
    .crud-orders-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-orders-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-orders-wizard .wizard-footer-left > span,
    .crud-orders-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-orders-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud-orders-nro-internal {
    color: #6200ee;
    font-size: 12px;
  }
  .order-total-table-paid {
    color: darkgreen;
    font-weight: 700;
  }
  .order-total-table-nopaid {
    color: darkred;
    font-weight: 700;
  }
  .crud-orders-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-orders-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-orders-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-orders-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-orders-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-orders-totals__row + .crud-orders-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-orders-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-orders-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-orders-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-orders-totals__row--total .crud-orders-totals__label,
  .crud-orders-totals__row--total .crud-orders-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-orders-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-orders-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-orders-totals__discount input,
  .crud-orders-totals__discount select {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-orders-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
  .orders-form-modal-dialog {
    max-width: min(1400px, calc(100vw - 24px));
  }
  .orders-detail-modal-dialog {
    max-width: min(1400px, calc(100vw - 24px));
  }
</style>
<style scoped>
  hr {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  .crud-orders-observations {
    overflow: auto;
    max-height: 70px;
    font-size: 12px;
  }
  .crud-orders-consumer-extra {
    margin-top: 4px;
    margin-left: 29px;
    display: flex;
    align-items: center;
  }
  .crud-orders-consumer-trigger {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #0f4c81;
    text-decoration: none;
    max-width: 190px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .crud-orders-consumer-trigger:hover {
    text-decoration: underline;
  }
  .crud-orders-consumer-popover {
    max-width: 320px;
    font-size: 12px;
    line-height: 1.3;
  }
  .crud-orders-consumer-popover-row {
    margin-bottom: 3px;
  }
  .crud-orders-consumer-popover-label {
    font-weight: 700;
    margin-right: 4px;
  }
  .crud-orders-consumer-popover-value {
    white-space: pre-line;
    color: #111827;
  }
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
